import React from 'react';
import {SummaryValue} from './SummaryModal'
import {BackArrowIcon, Icon_BulletPoint, Icon_PBV, Icon_Warning, Icon_MedicalRecord, Icon_DropdownArrow, Icon_MedicalFacility, Icon_Doctor} from '../form/styles/assets/icons'

export const resetFormLists = ({userInput, formik}) => {
    let values = userInput
    for (let property in values) {
        if (property.includes('requesteditem') || property.includes('inputAuthorizeFacility') || property.includes('exclude')){
            delete values[property];
        }
    }
    formik.setValues({...values, test: 'test'})
    formik.values.inputPhysicianNames !== 'not_applicable' && formik.setFieldValue('inputPhysicianNames', "")
    // Clear the names stored on inputPhysicianName in case user makes new selections on resubmit
    formik.setFieldValue('txtotherrecords', "")
    // Clear the names stored on txtotherrecords in case user makes new selections on resubmit
}

export const doctorList = ({userInput, testFormSpec}) => {
    const doctorArray = [];
    for (let property in userInput) {
        property.includes('physician#') && doctorArray.push(<SummaryValue value={userInput[property]} icon={<Icon_Doctor color={testFormSpec.color}/>}/>)
    }
    return doctorArray;
}

export const sensitiveInfoDisclosures = (userInput) => {
    ['PSY', 'DRUG', 'HIV', 'STD', 'GENETIC', 'GENETICS'].filter((sensitiveItem) => {
        return !userInput.sensitiveInfo.includes(sensitiveItem.toUpperCase())
    })   
}

export const sensitiveInfoToggle = (sensitiveInfoDropped, setSensitiveInfoDropped) => {
    sensitiveInfoDropped ? setSensitiveInfoDropped(false) : setSensitiveInfoDropped(true)
}

export const consoleLogs = (userInput, formik) => {
    // console.log(JSON.parse(window.sessionStorage.userInput))
    // console.log(formik)
}

export const convertSubmissionObject = async (formik, orgId, outPatientSummaryList) => {
    // formik.setFieldValue('facilityList', formik.values.pdf_facilitiesList)
    const triPartiteOrg = orgId.includes('7042') || orgId.includes ('7101') || orgId.includes('7239')
    const bothwell = orgId.includes('1007302')
    let submissionObj = {}

    if (triPartiteOrg){ 
        submissionObj = {...formik.values, facilityList: [formik.values.pdf_facilitiesList], pdf_facilitiesList: formik.values.pdf_facilitiesList + `${formik.values.facilityOther ? ', ' + formik.values.facilityOther : ''}` + `${outPatientSummaryList.length > 0 ? '   |   OUTPATIENT FACILITIES: ' + outPatientSummaryList : ''}`, outPatientFacilities: outPatientSummaryList} 
    }
    else if (bothwell) {
        submissionObj = {...formik.values, facilityList: [formik.values.pdf_facilitiesList], pdf_facilitiesList: formik.values.pdf_facilitiesList + `${formik.values.physicianList ? ', ' + formik.values.physicianList : ''}` + `${formik.values.facilityOther ? ', ' + formik.values.facilityOther : ''}`}
    }
    else {
        submissionObj = {...formik.values, facilityList: [formik.values.pdf_facilitiesList], pdf_facilitiesList: formik.values.pdf_facilitiesList + `${formik.values.facilityOther ? ', ' + formik.values.facilityOther : ''}`}
    }
    // formik.setFieldValue('pdf_facilitiesList', `${formik.values.pdf_facilitiesList} + ${formik.values.facilityOther}`)
    return submissionObj
}